var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',[_c('recommender-informal')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }